import React from "react";
import { Link } from "react-router-dom";
import translations from "../../translation";

const ActiveUsers = ({ count = "N/A", link = "/admin/users", language = "en" }) => {
  const translate = (key) => translations[language]?.[key] || key;

  return (
    <Link to={link}>
      <div className="bg-white overflow-hidden shadow rounded-lg hover:shadow-md transition-shadow">
        <div className="p-5">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <i className="fas fa-users text-green-500 text-3xl" />
            </div>
            <div className="ml-5 w-0 flex-1">
              <dl>
                <dt className="text-sm font-medium text-gray-500 truncate">
                  {translate("activeUsers")}
                </dt>
                <dd className="text-3xl font-semibold text-gray-900">
                  {count}
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ActiveUsers;
